import React, { Component } from "react";
import PropTypes from "prop-types";
import Title from "../Title";
import CartColumns from "./CartColumns";
import EmtyCart from "./EmtyCart";
import { ProductConsumer } from "../../context";
import CartList from "./CartList";
import CartTotals from "./CartTotals";

export default class Cart extends Component {
  render() {
    return (
      <section>
        <ProductConsumer>
          {value => {
            const { cart } = value;
            if (cart.length) {
              return (
                <React.Fragment>
                  <Title name="your" title="cart" />
                  <CartColumns />
                  <CartList value={value} />
                  <CartTotals value={value} history={this.props.history} />
                </React.Fragment>
              );
            } else {
              return <EmtyCart />;
            }
          }}
        </ProductConsumer>
      </section>
    );
  }
}

Cart.propTypes = {
  history: PropTypes.object.isRequired
};
